import React, { FunctionComponent } from 'react';
import { Container } from '@mlc/web-ui-toolkit';
import { NavigationTree } from '../../logic/domains/navigationTree.domain';
import HeaderContainer from '../containers/Header/HeaderContainer';
import FooterLinksContainer from '../containers/Footer/FooterLinksContainer';
import FooterDisclaimerContainer from '../containers/Footer/FooterDisclaimerContainer';

interface Props {
	children: JSX.Element | JSX.Element[];
	navigationTree: NavigationTree;
}

const SecureLayout: FunctionComponent<Props> = ({
	children,
	navigationTree,
}) => (
	<Container themeName="mlc">
		<HeaderContainer navigationTree={navigationTree} />
		{children}
		<FooterLinksContainer />
		<FooterDisclaimerContainer />
	</Container>
);

export default SecureLayout;
